export const catalogueConstants = {
    GETALL_REQUEST: 'CATALOGUE_GETALL_REQUEST',
    GETALL_SUCCESS: 'CATALOGUE_GETALL_SUCCESS',
    GETALL_FAILURE: 'CATALOGUE_GETALL_FAILURE',

    DELETE_REQUEST: 'CATALOGUE_DELETE_REQUEST',
    DELETE_SUCCESS: 'CATALOGUE_DELETE_SUCCESS',
    DELETE_FAILURE: 'CATALOGUE_DELETE_FAILURE'
};
